import { getElectronAPI } from "../electron";

interface BasePrinterTarget {
  enabled: boolean;
}

interface NetworkPrinterTarget extends BasePrinterTarget {
  type: "NETWORK";
  address: string;
  port?: number;
}

interface UsbPrinterTarget extends BasePrinterTarget {
  type: "USB";
  usbVendorId: string;
  usbProductId: string;
}

export type PrinterTarget = NetworkPrinterTarget | UsbPrinterTarget;

export type PrinterLike = {
  type: string;
  enabled: boolean;
  address?: string | null;
  port?: number | null;
  usbVendorId?: string | null;
  usbProductId?: string | null;
};

export function toPrinterTarget(printer: PrinterLike): PrinterTarget {
  if (printer.type === "NETWORK") {
    return {
      type: "NETWORK",
      enabled: printer.enabled,
      address: printer.address ?? "",
      port: printer.port ?? undefined,
    };
  }

  if (printer.type === "USB") {
    return {
      type: "USB",
      enabled: printer.enabled,
      usbVendorId: printer.usbVendorId ?? "",
      usbProductId: printer.usbProductId ?? "",
    };
  }

  throw new Error(`Unsupported printer type: ${printer.type}`);
}

let cachedPrinter: PrinterTarget | null = null;

export function setSelectedPrinter(printer: PrinterTarget | null): void {
  cachedPrinter = printer;
}

export async function printViaElectron(zpl: string): Promise<void> {
  const api = getElectronAPI();
  if (!api) {
    throw new Error("Electron API not available");
  }

  const printer = cachedPrinter;
  if (!printer) {
    throw new Error("No printer selected. Configure a printer in Settings.");
  }
  if (!printer.enabled) {
    throw new Error("Selected printer is disabled.");
  }

  const result = await api.printZpl(zpl, printer);
  if (!result.success) {
    throw new Error(result.error ?? "Print failed");
  }
}
